import { all } from "redux-saga/effects";

import * as watchers from "./watchers";

export default function* rootSaga() {
  yield all([
    watchers.watchGetMyTopologies(),
    watchers.watchDelete(),
    watchers.watchGetTasks(),
    watchers.watchResetTask(),
    watchers.watchSkipTask(),
    watchers.watchPauseTask(),
    watchers.watchGetTaskLogs(),
    watchers.watchGetPropertyBag(),
    watchers.watchUploadPropertyBag(),
    watchers.watchGetTopologyTypesSaga(),
    watchers.watchGetCloudTypesDefaultClassicSaga(),
    watchers.watchCheckoutTopologySaga(),
    watchers.watchUploadTemplateSaga(),
    watchers.watchUploadTemplateForLookupFileSaga(),
    watchers.watchUploadLookupFileSaga(),
    watchers.watchDeployPrivateTemplateSaga(),
    watchers.watchDeployLookupTopologyTypeSaga(),
    watchers.watchRenameTopologySaga(),
    watchers.watchTransferOwnershipSaga(),
    watchers.watchGetDebuggerPortSaga(),
    watchers.watchDeployTopologyTypeWithQueueSaga(),
    watchers.watchGetMyQueueRequestsSaga(),
    watchers.watchCancelQueueRequestSaga(),
    watchers.watchGetDuplicateThresholdTopologiesSaga(),
    watchers.watchGetUserRegionSaga(),
  ]);
}
